export const config = {
  src: [
    'audiosprites/audio.ogg',
    'audiosprites/audio.mp3',
  ],
  sprite: {
    appear_lines: [
      0,
      1310.5442176870747,
    ],
    big_win: [
      3000,
      2420.589569160997,
    ],
    button_spin: [
      7000,
      1138.458049886621,
    ],
    cascade_explosion: [
      10000,
      2939.54648526077,
    ],
    cascade_spin: [
      14000,
      2034.5804988662123,
    ],
    confeti_shots: [
      18000,
      4036.8707482993213,
    ],
    dragon: [
      24000,
      1622.8798185941039,
    ],
    end_free_spin: [
      27000,
      2299.092970521542,
    ],
    end_to_main: [
      31000,
      3487.3015873015875,
    ],
    free_bet_big_win: [
      36000,
      1362.3129251700661,
    ],
    free_bet_mega_win: [
      39000,
      2207.9138321995442,
    ],
    free_bet_total_win: [
      43000,
      973.3560090702938,
    ],
    free_bet_ultra_win: [
      45000,
      1297.414965986391,
    ],
    free_spin_ambient: [
      48000,
      42410.56689342403,
    ],
    free_spin_music: [
      92000,
      95302.74376417234,
    ],
    free_spin_popup: [
      189000,
      4968.70748299321,
    ],
    free_spin_start: [
      195000,
      2502.0861678004567,
    ],
    inside_buttons: [
      199000,
      635.0566893424059,
    ],
    main_ambient: [
      201000,
      49731.31519274375,
    ],
    main_music: [
      252000,
      144770.63492063497,
    ],
    mega_win: [
      398000,
      2113.356009070287,
    ],
    mult_land: [
      402000,
      2086.8934240363046,
    ],
    mult_port: [
      406000,
      2086.8934240363046,
    ],
    outside_buttons: [
      410000,
      1141.4512471655485,
    ],
    reel_spin: [
      413000,
      2047.6643990929801,
    ],
    reel_stop_01: [
      417000,
      153.76417233562734,
    ],
    reel_stop_02: [
      419000,
      179.47845804991402,
    ],
    reel_stop_03: [
      421000,
      181.40589569162557,
    ],
    reel_stop_04: [
      423000,
      184.96598639455897,
    ],
    reel_stop_05: [
      425000,
      200.77097505668462,
    ],
    regular_win: [
      427000,
      1013.1065759637181,
    ],
    scatter_stop: [
      430000,
      1561.9954648526004,
    ],
    tap_to_play: [
      433000,
      6669.909297052129,
    ],
    ultra_win: [
      441000,
      2375.850340136026,
    ],
    wild_stop: [
      445000,
      817.891156462565,
    ],
  },
}
